import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import EdgescanConfigListing from './EdgescanConfigListing'
import EdgescanCredentialsForm from './EdgescanCredentialsForm'

export default function EdgescanPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            RunOnDemandButtonText={'Sync tool assets'}
            PullCredentialForm={EdgescanCredentialsForm}
            PullConfigListingView={EdgescanConfigListing}
        />
    )
}